import { createEventFactory, createName } from '@cp/shared/tracking';

export const deleteProfileClick = createEventFactory({ name: createName('client', 'delete', 'click') });

export const deleteModalOpen = createEventFactory({
  name: createName('client', 'delete'),
  goalId: 'poyavlenie_popapa_udalit_profil_',
  goalName: 'Появление попапа "Удалить профиль?"',
});

export const deleteConfirm = createEventFactory({
  name: createName('client', 'delete', 'confirm'),
  goalId: 'nazhatie_na_knopku_da,_udalit',
  goalName: 'Нажатие на кнопку "Да, удалить"',
});
